export const SuggestionType = {
  MOVE_TASK_DATE: "move_task_date",
  MOVE_STAGE_TO_NEXT_SLOT: "move_stage_to_next_slot",
  RESCHEDULE_FIRING: "reschedule_firing",
  RESCHEDULE_BATCH: "reschedule_batch",
};

/**
 * @typedef {Object} PlannerSuggestion
 * @property {string} id
 * @property {"move_task_date"|"move_stage_to_next_slot"|"reschedule_firing"|"reschedule_batch"} type
 * @property {string} title
 * @property {string} message
 * @property {string=} taskId
 * @property {string=} firingId
 * @property {string=} fromDate
 * @property {string=} toDate
 * @property {string} createdAt
 * @property {boolean} applied
 */
